// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root level containment */
html, body {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}

/* Main container */
.popular-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* Controls section */
.controls {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.dropdown-selector {
  flex: 1 1;
  min-width: 200px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-right: 20px;
  box-sizing: border-box;
}

.dropdown-selector label {
  font-weight: bold;
  margin-bottom: 5px;
  width: 100%;
}

.dropdown-selector select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  background-color: #f0f0f0;
  font-size: 1rem;
  box-sizing: border-box;
}

/* Results section */
.results {
  width: 100%;
  max-width: 100%;
  margin-top: 20px;
  box-sizing: border-box;
  overflow-x: hidden;
}

.results ul {
  width: 100%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.results li {
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #0381ff;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  flex-wrap: wrap;
}

/* Mobile-specific styles */
@media (max-width: 768px) {
  .popular-page {
    padding: 10px;
  }

  .controls {
    gap: 10px;
  }

  .dropdown-selector {
    margin-right: 0;
    min-width: 100%;
  }

  .results li {
    padding: 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .results .rank,
  .results .code,
  .results .name,
  .results .enrollment {
    width: 100%;
    margin: 2px 0;
  }

  .average-rating {
    width: 100%;
    text-align: left;
    margin: 5px 0 !important;
  }
}

/* Keep existing rating classes */
.rating-excellent {
  color: #007bff !important;
}

.rating-good {
  color: #28a745 !important;
}

.rating-fair {
  color: #ffc107 !important;
}

.rating-mediocre {
  color: #fd7e14 !important;
}

.rating-poor {
  color: #dc3545 !important;
}

.average-rating {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 10px !important;
  width: 100%;
  box-sizing: border-box;
}

/* Error handling */
.error {
  width: 100%;
  color: #dc3545;
  font-size: 1.2rem;
  text-align: center;
  margin-top: 20px;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/ProfessorPage.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;;;;IAIE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,wBAAwB;EAC1B;AACF;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["/* Root level containment */\nhtml, body {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n/* Main container */\n.popular-page {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n/* Controls section */\n.controls {\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 20px;\n  box-sizing: border-box;\n}\n\n.dropdown-selector {\n  flex: 1;\n  min-width: 200px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-right: 20px;\n  box-sizing: border-box;\n}\n\n.dropdown-selector label {\n  font-weight: bold;\n  margin-bottom: 5px;\n  width: 100%;\n}\n\n.dropdown-selector select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  background-color: #f0f0f0;\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n/* Results section */\n.results {\n  width: 100%;\n  max-width: 100%;\n  margin-top: 20px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.results ul {\n  width: 100%;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.results li {\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 10px;\n  background-color: #0381ff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  flex-wrap: wrap;\n}\n\n/* Mobile-specific styles */\n@media (max-width: 768px) {\n  .popular-page {\n    padding: 10px;\n  }\n\n  .controls {\n    gap: 10px;\n  }\n\n  .dropdown-selector {\n    margin-right: 0;\n    min-width: 100%;\n  }\n\n  .results li {\n    padding: 8px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n\n  .results .rank,\n  .results .code,\n  .results .name,\n  .results .enrollment {\n    width: 100%;\n    margin: 2px 0;\n  }\n\n  .average-rating {\n    width: 100%;\n    text-align: left;\n    margin: 5px 0 !important;\n  }\n}\n\n/* Keep existing rating classes */\n.rating-excellent {\n  color: #007bff !important;\n}\n\n.rating-good {\n  color: #28a745 !important;\n}\n\n.rating-fair {\n  color: #ffc107 !important;\n}\n\n.rating-mediocre {\n  color: #fd7e14 !important;\n}\n\n.rating-poor {\n  color: #dc3545 !important;\n}\n\n.average-rating {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-top: 10px !important;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Error handling */\n.error {\n  width: 100%;\n  color: #dc3545;\n  font-size: 1.2rem;\n  text-align: center;\n  margin-top: 20px;\n  box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
